export default __webpack_public_path__ + "static/media/broadband_fibre.d63be107.png";